import { RedirectState } from '@neo.tax/shared';

export const useExportAscRedirect = (): RedirectState => ({ isLoading: false });
